import { render } from "./PortalGiftTemplateCommon.vue?vue&type=template&id=2179f87b"
import script from "./PortalGiftTemplateCommon.vue?vue&type=script&lang=js"
export * from "./PortalGiftTemplateCommon.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__